<template>
  <div>
    <a-card class="margin-top-20" title="表型记录" :headStyle="headStyle">
      <template #extra>
        <a-button
          type="default"
          bordered="false"
          shape="round"
          @click="showModal('add')"
          style="float: right"
          >添加表型记录</a-button
        >
      </template>
      <a-tabs default-active-key="1">
        <a-tab-pane key="1" tab="图表">
          <a-empty v-if="!chartData" description="暂无数据" />
          <chart-line :height="310" :data="chartData" v-else></chart-line>
        </a-tab-pane>
        <a-tab-pane key="2" tab="表格">
          <a-empty v-if="tableData.length === 0" description="暂无数据" />
          <a-table :columns="columns" :dataSource="tableData" v-else> 
            <template slot="height" slot-scope="height, row">{{ row.height || '-' }}</template>
            <template slot="shen_chang" slot-scope="shen_chang, row">{{ row.shen_chang || '-' }}</template>
            <template slot="weight" slot-scope="weight, row">{{ row.weight || '-'}}</template>
            <template slot="width" slot-scope="width, row">{{ row.width || '-'}}</template>
            <template slot="chest_girth" slot-scope="chest_girth, row">{{ row.chest_girth || '-'}}</template>
            <template slot="recorded_at" slot-scope="recorded_at, row">{{ row.recorded_at || '-'}}</template>
            <template slot="operations" slot-scope="scope, row">
              <a-button type="primary" size="small" @click="showModal('edit', row)">编辑</a-button>
              <a-button type="danger" size="small" @click="handleDelete(row.id)" class="margin-left-10">删除</a-button>
            </template>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-card>
    <a-modal
      title="录入数据"
      v-model:visible="isModalVisible"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <a-form :form="formRef" :rules="rules">
        <a-form-item label="身高" :rules="rules.height">
          <a-input v-model="form.height" />
        </a-form-item>
        <a-form-item label="身长" :rules="rules.shen_chang">
          <a-input v-model="form.shen_chang" />
        </a-form-item>
        <a-form-item label="体重" :rules="rules.weight">
          <a-input v-model="form.weight" />
        </a-form-item>
        <a-form-item label="体宽" :rules="rules.width">
          <a-input v-model="form.width" />
        </a-form-item>
        <a-form-item label="胸围" :rules="rules.chest_girth">
          <a-input v-model="form.chest_girth" />
        </a-form-item>
        <a-form-item label="记录日期" :rules="rules.recorded_at">
          <a-date-picker v-model="form.recorded_at" />
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import ChartLine from "@/components/Charts/ChartLine.vue";
export default {
  name: "BiaoXingRecords",
  components: {
    ChartLine,
  },
  props: {
    item_id: {
      type: Number,
      default: 0,
    },
    farm_id: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      isModalVisible: false,
      form: {
        farm_id: "",
        height: "",
        shen_chang: "",
        weight: "",
        width: "",
        chest_girth: "",
        recorded_at: "",
        breed_item_id: ""
      },
      formRef: this.$form.createForm(this),
      query: {
        breed_item_id: "",
        start_at: "",
        end_at: "",
        farm_id: "",
        page_no: "",
        page_size: "",
      },
      tableData: [],
      editMode: "add",
      columns: [
        {
          title: "身高",
          dataIndex: "height",
          key: "height",
          scopedSlots: { customRender: "height" },
        },
        {
          title: "身长",
          dataIndex: "shen_chang",
          key: "shen_chang",
          scopedSlots: { customRender: "shen_chang" },
        },
        {
          title: "体重",
          dataIndex: "weight",
          key: "weight",
          scopedSlots: { customRender: "weight" },
        },
        {
          title: "体宽",
          dataIndex: "width",
          key: "width",
          scopedSlots: { customRender: "width" },
        },
        {
          title: "胸围",
          dataIndex: "chest_girth",
          key: "chest_girth",
          scopedSlots: { customRender: "chest_girth" },
        },
        {
          title: "记录日期",
          dataIndex: "recorded_at",
          key: "recorded_at",
          scopedSlots: { customRender: "recorded_at" },
        },
        {
          title: "操作",
          dataIndex: "operations",
          key: "operations",
          scopedSlots: { customRender: "operations" },
        },
      ],
      headStyle: {
        backgroundColor: "#2563EB", // 自定义 header 背景色
        color: "#efefef", // 自定义 header 文字颜色
        "border-radius": "10px 10px 0px 0px",
        "font-weight": "bold",
      },
      chartData: undefined,
      rules: {
        height: [
          {
            required: true,
            message: "请输入身高",
          },
          {
            pattern: /^\d+(\.\d+)?$/,
            message: "请输入有效的数字",
          },
        ],
        shen_chang: [
          {
            required: true,
            message: "请输入身长",
          },
          {
            pattern: /^\d+(\.\d+)?$/,
            message: "请输入有效的数字",
          },
        ],
        weight: [
          {
            required: true,
            message: "请输入体重",
          },
          {
            pattern: /^\d+(\.\d+)?$/,
            message: "请输入有效的数字",
          },
        ],
        width: [
          {
            pattern: /^\d+(\.\d+)?$/,
            message: "请输入有效的数字",
          },
        ],
        chest_girth: [
          {
            pattern: /^\d+(\.\d+)?$/,
            message: "请输入有效的数字",
          },
        ],
        recorded_at: [
          {
            required: true,
            message: "请选择记录日期",
          },
        ],
      },
    };
  },
  methods: {
    showModal(action, item) {
      if (action === "add") {
        this.isModalVisible = true;
        this.formRef.resetFields();
        this.editMode = action;
      } else {
        this.form = item;
        this.editMode = action;
        this.isModalVisible = true;
      }
    },
    handleOk() {
      this.form.farm_id = this.farm_id;
      if (this.editMode === "add") {
        this.formRef.validateFields((err, values) => {
          if (!err) {
            this.$api.post_biao_xing_records(this.form).then(() => {
              this.isModalVisible = false;
              this.getTableData();
              this.refreshChart();
            });
          }
        });
      } else {
        this.formRef.validateFields((err, values) => {
          if (!err) {
            this.$api.putBiaoXingRecord(this.form.id, this.form).then(() => {
              this.isModalVisible = false;
              this.getTableData();
              this.refreshChart();
            });
          }
        });
      }
    },
    handleCancel() {
      this.isModalVisible = false;
    },
    async refreshChart() {
      const res = await this.$api.getBiaoXingChartData({breed_item_id: this.item_id});
      this.chartData = res.data;
    },
    getTableData() {
      const params = {
        breed_item_id: this.item_id,
      };
      this.$api.get_biao_xing_records(params).then((res) => {
        this.tableData = res.data;
      });
    },
    handleDelete(id) {
      const _self = this
      this.$confirm({
        title: "确定删除该条数据吗？",
        okText: "确定",
        okType: "danger",
        cancelText: "取消",
        onOk() {
          _self.$api.delete_biao_xing_record(id).then((res) => {
            if (res.code == 200) {
              _self.$message.success("删除成功");
              _self.getTableData();
              _self.refreshChart();
            }
          });
        },
        onCancel() {},
      })
    }
  },
  mounted() {
    this.getTableData();
    this.refreshChart();
    this.form.breed_item_id = this.item_id;
  },
};
</script>

<style scoped>
/* Add your component styles here */
</style>